exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control {\n  padding: 0.35rem .75rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-item-editor/check-off-item-editor.component.less
// module id = ./src/app/checkoffs/check-off-item-editor/check-off-item-editor.component.less
// module chunks = 0